module.exports = __webpack_public_path__ + "img/credit-card.6c2dc411.svg";